var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-180,-990)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8,0,0,0.109632,-142.323,481.464)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "rgb(255,28,28)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8,0,0,0.109632,-142.323,477.846)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8,0,0,0.109632,-142.323,474.228)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "rgb(255,28,28)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8,0,0,0.109632,-142.323,470.61)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8,0,0,0.109632,-142.323,466.992)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "rgb(255,28,28)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8,0,0,0.109632,-142.323,463.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.416,0,0,0.109632,69.992,459.757)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "rgb(255,28,28)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.416,0,0,0.109632,69.992,456.139)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.416,0,0,0.109632,69.992,452.521)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "rgb(255,28,28)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.416,0,0,0.109632,69.992,448.903)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.416,0,0,0.109632,69.992,445.285)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "rgb(255,28,28)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.416,0,0,0.109632,69.992,438.05)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "rgb(255,28,28)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.416,0,0,0.109632,69.992,441.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.384,0,0,0.767426,25.2849,-167.121)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "rgb(0,145,255)"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUs);
export default __webpack_public_path__ + "static/media/flag_us.9dbce6f3e8c669667ffda69fef396718.svg";
export { ForwardRef as ReactComponent };